import React, { useState } from 'react'
import { Form, Input } from 'antd'
import { useTranslation } from 'lib/i18n'

import styles from './Details.module.css'

const { TextArea } = Input

export default function Details({
  profileName,
  placeholderCopy,
  maxDetailsCount,
  customLabel,
  ...props
}) {
  const { t } = useTranslation()
  const [charCount, setCharCount] = useState(
    maxDetailsCount - (props?.value?.length || 0),
  )

  const handleKeyUp = (e) => {
    const charsLeft = maxDetailsCount - e.target.value.length
    setCharCount(charsLeft)
  }

  return (
    <Form.Item
      {...props}
      name={['VIDEO_REQUEST', 'details']}
      label={
        customLabel ||
        t(
          'VideoRequestForm.detailsLabel',
          'Other details, e.g. pronounciations',
          {
            profileName,
            charCount: Math.max(charCount, 0),
          },
        )
      }
    >
      <TextArea
        {...props}
        placeholder={placeholderCopy}
        style={{ minHeight: 160, fontSize: 16 }}
        onKeyUp={handleKeyUp}
      />

      <div className={styles.charCount}>
        {t(
          'VideoRequestForm.charactersRemaining',
          '{{charCount}} characters remaining',
          {
            charCount,
          },
        )}
      </div>
    </Form.Item>
  )
}
